import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { VueAxios } from './axios'
import notification from 'ant-design-vue/es/notification'
import { ACCESS_TOKEN,TENANT_ID } from '@/store/mutation-types'
import url from './url'

const vue=new Vue({})
// 创建 axios 实例
const service = axios.create({
  baseURL: url, // api base_url
  timeout: 6000 // 请求超时时间
})

const err = (error) => {
  if (error.response) {
    const data = error.response.data
    const token = Vue.ls.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      notification.error({ message: 'Forbidden', description: data.message})
    }
    if (error.response.status === 401) {
      notification.error({ message: 'Unauthorized', description: 'Authorization verification failed' })
      if (token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
      }
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    config.headers[ 'Authorization' ] = 'Bearer ' + token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  const tenantid=Vue.ls.get(TENANT_ID)
  if(tenantid){
    config.headers.common[TENANT_ID]=tenantid
  }
  return config
}, err)

// response interceptor
service.interceptors.response.use((response) => {
    return response.data
  }, err=>{
    if(err.response&&err.response.data&&err.response.data.__abp){
      if(err.response.data.success==false){
        if (err.response.data.error.details) {
          vue.$error({content:err.response.data.error.details, title:err.response.data.error.message})
        } else {
          vue.$error({title:err.response.data.error.message || '调用服务发生未知异常!'})
        }
      }
    }else{
      vue.$error({title:'调用服务发生未知异常!'})
    }
    console.log(err)
    return err
})

const installer = {
  vm: {},
  install (Vue, router = {}) {
    Vue.use(VueAxios, router, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}